import { render, staticRenderFns } from "./LearningGoalQuizForm.vue?vue&type=template&id=2d7b3c20&"
import script from "./LearningGoalQuizForm.vue?vue&type=script&lang=js&"
export * from "./LearningGoalQuizForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports